var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderPurchase',{attrs:{"header":"แก้ไขรายละเอียด","img_header":_vm.header_image,"link_back":"purchase"}}),_c('Purchase_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }